module.exports = __webpack_public_path__ + "img/w3_share_light.4ae055be.png";